import { FormattedPriceDisplay } from './price-total.styles';

export type PriceDisplayProps = {
  readonly formattedPrice: string;
  readonly fontSize: string;
};

export const PriceDisplay = ({
  formattedPrice,
  fontSize
}: PriceDisplayProps) => (
  <div css={FormattedPriceDisplay}>
    <div style={{ fontSize }}>
      {formattedPrice}
      <span> USD</span>
    </div>
  </div>
);
